
  /*jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true */


/*
*	jquery.propoScript.js
*              ___		\/)'/
*        _____|| ||_____ (o//\    *BEEP BOOP*
*        | o  |___|  o |\o)/
*        |   [(o==)]   |)
*        |_____| |_____|
*   ___  ____//\_/\\____  ___
*  |   | |_|___\_/___|_| |   |
* [|   |]| |===      | |[|   |]
*  |___| |_|o_______o|_| |___|
*   \ |    \|_______|/    | /
*  _|_|_    [__|_|__]    _|_|_
*  |___|      |___|      |___|  
*  |   |       | |       |   |
*             [| |]
*/

/**
*	jQuery plugin to create and apply pseudo-responsiveness (scaling) to non-responsive webpage designs
*	@version 0.0.3
*	@author Aric Ng
* 	
*	Added non-propoContainer parent override
*/

/**
* jQuery.
* @external "$"
 * @see {@link http://jquery.com/ | jQuery}
*/

/**
* The jQuery plugin namespace.
* @external "$.fn"
 * @see {@link http://learn.jquery.com/plugins/|jQuery Plugins}
*/



jQuery(function($)
{
	"use strict";
	var propoScriptProps = {
		init: false,
		initSettings: {},
		disabled: false
	};
	
	/*
	* @function getInternetExplorerVersion
	* @description Returns the version of Internet Explorer or a -1 (indicating the use of another browser).
	* @see: https://msdn.microsoft.com/en-us/library/ms537509(v=vs.85).aspx
	* @returns {Number} -1 if not any IE version, any other number otherwise
	*/
	function getInternetExplorerVersion() {
	'use strict';
	  var rv = -1,
		ua,
		re,
		verStringArr;

		// works up to IE 10 but IE 11 spoofs this value. seperate check for IE Edge
		if (navigator.appName === 'Microsoft Internet Explorer') {
			ua = navigator.userAgent;
			re  = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');
			if (re.exec(ua) !== null) rv = parseFloat( RegExp.$1 );
		} else if (navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Trident') > -1) {
			rv = 11;
		} else if(navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Edge') > -1) {
			ua = navigator.userAgent;
			re = new RegExp('Edge\/([0-9]{1,}[\.0-9]{0,})');
			verStringArr = re.exec(ua);
			if(verStringArr.length !== 0) rv = Math.floor(parseFloat(verStringArr[0].split('/')[1]));
		}
		return rv;
	}
	
	// Resize event handling for propoScript 
	// propoResize is an exclusive resize event to prevent resize event overlap
	$(window).on('resize propoResize', function(){
		// Resize root propoContainers only
		if(propoScriptProps.disabled)
			return;
		
		$('.propoContainer.root').each(function(){
			var $this = $(this),
			max_width = $this.data('max_width'),
			max_height = $this.data('max_height'),
			scale;
		
			// Needs at least a max-width or a max-height
			if(max_width === undefined && max_height === undefined)
				return;
		
			// Use max-width first, then defer to max-height if undefined
			scale = max_width !== undefined ? $this.width()/max_width : $this.height()/max_height;
			$this.css(max_width !== undefined ? 'height' : 'width', $this.data(max_width !== undefined ? 'max_height' : 'max_width')*scale+'px');
		});
	
		// Resize propoText elements
		$('.propoText').each(function(){
			var $this = $(this),
			$parent = $($this.parents('.propoContainer')[0]),
			max_width = $parent.data('max_width'),
			max_height = $parent.data('max_height'),
			scale,
			css_data = {};
		
			if(max_width === undefined && max_height === undefined)
				return;
			
			scale = max_width !== undefined ? $parent.width()/max_width : (max_height !== undefined ? $parent.height()/max_height : false);
			
			if(!scale)
				return;
			
		
			if($this.data('font_size'))
				css_data.fontSize = $this.data('font_size')*scale;

			if($this.data('letter_spacing'))
				css_data.letterSpacing = $this.data('letter_spacing')*scale;
		
			$this.css(css_data);
		});
		
		// Elements with propoOverride have hard left/right/width/height adjustments on resize
		$('.propoOverride').each(function(){
			var $this = $(this),
			$parent = $this.data('propoOverrideParent'),
			parent_max_width = $parent.data('max_width'),
			parent_max_height = $parent.data('max_height'),
			positions = $this.data('propoPositions'),
			max_width = $this.data('propoMaxWidth'),
			max_height = $this.data('propoMaxHeight'),
			scale,
			css_properties = {};
			
			scale = parent_max_width !== undefined ? $parent.width()/parent_max_width : (parent_max_height !== undefined ? $parent.height()/parent_max_height : false);
			
			if(!scale)
				return;
			
			// Add adjusted positions
			for(var position in positions)
			{
				if(positions.hasOwnProperty(position))
					css_properties[position] = positions[position]*scale;
			}
			
			// Add widths
			if(max_width !== undefined)
				css_properties.width = max_width*scale;
			
			// Add height
			if(max_height !== undefined)
				css_properties.height = max_height*scale;
			$this.css(css_properties);
		});
	});
		var defaults = {
		debug: false,
		overrideNonPropoOffsetParents: false	
	};

	/**
	* @function extendDefaults
	* Helper function that extends propoScript default option values
	* @name extendDefaults
	* @param {object} options - Contains options
	* @returns {object} - An object with extended defaults based on options
	*/
	function extendDefaults(options) {
		var extended = {};
		for(var prop in defaults)
		{
			if(defaults.hasOwnProperty(prop) === true)
			{
				if(options.hasOwnProperty(prop) === true)
					extended[prop] = options[prop];
				else
					extended[prop] = defaults[prop];
			}
		}
		return extended;
	}

	/**
	* Helper function that processes all propo-classes. Classes are processed in this order, propoContainer (must be first!), propoElement, and propoText.
	* @name processPropoItems
	* @function external:"$".processPropoItems
	* @param {object} options - Contains options
	* 	@param {boolean} [options.debug=false] - Enables debug messages if true, will be false if console does not exist.
	*	@param {boolean} [options.overrideNonPropoOffsetParents=false] - PropoElement related, Allows pixel resizing and px positioning when needed (when propoContainer isn't the offset parent)
	*/
	$.processPropoItems = function(options){
		options = extendDefaults(options);
		propoScriptProps.initSettings = options;
		var debug = options.debug !== undefined ? (window.console ? options.debug : false) : false,
		overrideNonPropoOffsetParents = options.overrideNonPropoOffsetParents !== undefined ? options.overrideNonPropoOffsetParents : false;
	
	
		$('head').append('<style>.propoProcessing {display:none !important;}\n .propoElement {position: absolute;}\n .propoContainer {position: relative;}</style>');
	
		/* BEGIN: propoContainers */
		if(debug)
			console.log('<<<<<< processPropoItems: processPropoContainer: Start >>>>>>');
		$('.propoContainer').each(function(){
			var $this = $(this);
			$this.processPropoContainer(options);
		});
	
		if(debug)
			console.log('<<<<<< processPropoItems: processPropoContainer: End >>>>>>');
		/* END: propoContainers */
	
		/* BEGIN: propoElements */
		if(debug)
			console.log('<<<<<< processPropoItems: processPropoElement: Start >>>>>>');
		$('.propoElement').each(function(){
			var $this = $(this);
			$this.processPropoElement(options);
		});
		if(debug)
			console.log('<<<<<< processPropoItems: processPropoElement: End >>>>>>');
		/* END: propoElements */
	
		/* BEGIN: propoTexts */
		if(debug)
			console.log('<<<<<< processPropoItems: processPropoText: Start >>>>>>');
		$('.propoText').each(function(){
			var $this = $(this);
			$this.processPropoText(options);
		});
		if(debug)
			console.log('<<<<<< processPropoItems: processPropoText: End >>>>>>');
	
		/* Initialize the position and size of propoOverride marked elements */
		if(overrideNonPropoOffsetParents)
		{
			if(debug)
				console.log('<<<<<< processPropoItems: OVERRIDE: INIT Resizing >>>>>>');
			$(window).trigger('propoResize');
		}
		/* END: propoTexts */
	
		propoScriptProps.init = true;
	};

	/**
	* Processes an element with the propoContainer class. PropoContainers that do not reside in another propoContainer will be treated as 'root' containers
	* that will be affected by resize events. This function will not handle sizing or positioning, the target element should have the propoElement class and processPropoElement().
	* Note: propoContainers needs hard values for height 
	* If it's a root propoContainer, it will scale based on how it's squished by its parent, otherwise scaling and positioning should be deferred to propoElement by including the mentioned class
	* @name processPropoContainer
	* @function external:"$.fn".processPropoContainer
	* @param {object} options - Contains options
	* 	@param {boolean} [options.debug=false] - Enables debug messages if true, will be false if console does not exist.
	*/

	$.fn.processPropoContainer = function(options){
		options = extendDefaults(options);
	
		var $this = $(this),
		debug = options.debug !== undefined ? (window.console ? options.debug : false) : false,
		css_max_width,
		css_max_height,
		max_width,
		max_height,
		regex_percent = /[0-9]+%{1}/,
		regex_px = /[0-9]+(px){1}/,
		css_properties = {},
		updated_properties = [],
		prop; // Used to store updated properties so the script knows what to blow away if needed
	
		if(debug)
			console.log('<<< processPropoContainer: Start: For id:', $this.attr('id'), 'class:', $this.attr('class'), '>>>');
	
		// Must have propoContainer class to process
		if(!$this.hasClass('propoContainer'))
		{
			if(debug)
				console.log('processPropoContainer: Failed');
			return;
		}
	
		// Clear data and if root, clear css values
		if($this.hasClass('propoContainerReady'))
		{
			$this.removeData(['max_width', 'max_height']);
			if($this.hasClass('root'))
			{
				$this.css({
					width: '',
					height: ''
				});
				$this.removeClass('root');
			}
			$this.removeClass('propoContainerReady');
		}
	
		// Get cleaned max-sizes
		css_max_width = $this.css('max-width');
		css_max_height = $this.css('max-height');
	
		/*
		Percentage values are not valid proportional scaling values
		*/
		if(regex_px.test(css_max_width))
			max_width = parseInt(css_max_width.replace('px', ''));
		else if(regex_percent.test(css_max_width))
			max_width = false;
		
		if(regex_px.test(css_max_height))
			max_height = parseInt(css_max_height.replace('px', ''));
		else if(regex_percent.test(css_max_height))
			max_height = false;
	
		/*
		propoContainer must have a max-width or max-height set in the CSS, otherwise there's
		nothing to proportionally scale off of 
		*/
	
		if(!max_width && !max_height)
		{
			if(debug)
				console.log('processPropoContainer: missing both max-width and max-height px values: element not a valid propoContainer');
			return;
		}
	
		// Used for propoElements to calculate sizing and positioning
		$this.data('max_width', max_width);
		$this.data('max_height', max_height);
	
		// This will be a root propoContainer which will size all other propoContainers after it, provided that they're propoElements(!), unless otherwise.
		if(!$this.hasClass('propoElement'))//$parent.is('html, body') || !$parent.hasClass('propoContainer'))
		{
			if(debug)
				console.log('processPropoContainer: root container detected');
		
			$this.addClass('root');
			$this.css(max_width ? 'width' : 'height', '100%');
			css_properties[max_width ? 'width' : 'height'] = '100%';
			if(max_width)
				css_properties['height'] = max_height*$this.width()/max_width+'px';
			
		
		}
		$this.data('propoCSS', css_properties);

		$this.css(css_properties);
		for(prop in css_properties)
		{
			if(css_properties.hasOwnProperty(prop))
				updated_properties.push(prop);
		}
		$this.data('propoContainerProps', updated_properties);

		$this.addClass('propoContainerReady');
	
		if(debug)
			console.log('<<< processPropoContainer: End: For id:', $this.attr('id'), 'class:', $this.attr('class'), '>>>');	
	};

	/**
	* Processes elements with the propoElement class. If max-width or max-height is found in the CSS, it will be treated as a scaling element. Without positioning values, the propoElement will use relative positioning instead; provided
	that the element has the necessary CSS for scaling it will still scale.
	* @name processPropoElement
	* @function external:"$.fn".processPropoElement
	* @param {object} options - Contains options
	* 	@param {boolean} [options.debug=false] - Enables debug messages if true, will be false if console does not exist.
	*	@param {boolean} [options.overrideNonPropoOffsetParents=false] - PropoElement related, allows pixel resizing and px positioning when needed (when propoContainer isn't the offset parent), percentage positioning used otherwise via resize/propoResize
	*/
	$.fn.processPropoElement = function(options){
		options = extendDefaults(options);
	
		var $this = $(this),
		debug = options.debug !== undefined ? (window.console ? options.debug : false) : false,
		overrideNonPropoOffsetParents = options.overrideNonPropoOffsetParents !== undefined ? options.overrideNonPropoOffsetParents : false,
		override_applied = false, // override 'mode' flag
		$parent = $this.offsetParent(),
		positions = {
			left: 0,
			right: 0,
			top: 0, 
			bottom: 0
		},
		raw_positions = { // Used for propoOverride if needed, they're px integer values without measurements
			left: 0, 
			right: 0, 
			top: 0, 
			bottom: 0
		},
		css_max_width,
		css_max_height,
		max_width,
		max_height,
		auto_count = 0,
		updated_properties = [], // Used to store updated properties so the script knows what to blow away if needed
		/*
		 Check for browser types; different browsers make jQuery return different position values depending on element being hidden or not, or % positioning as px.
		 */
		// See (for Safari): http://stackoverflow.com/questions/12625876/how-to-detect-chrome-and-safari-browser-webkit
		is_safari = navigator.userAgent.toLowerCase().indexOf('safari') > -1 && navigator.userAgent.toLowerCase().indexOf('chrome') === -1,
		//is_firefox = navigator.userAgent.indexOf('Firefox') > -1,
		is_ie = getInternetExplorerVersion() === -1 ? false : true,
		regex_percent = /[0-9]+%{1}/,
		regex_px = /[0-9]+(px){1}/;	
		if(debug)
			console.log('<<< processPropoElement: Start: For id:', $this.attr('id'), 'class:', $this.attr('class'), 'for propoContainer with id:', $parent.attr('id'), 'class:', $parent.attr('id'), '>>>');
	
		if((!($parent.hasClass('propoContainer') && $parent.hasClass('propoContainerReady'))  && !overrideNonPropoOffsetParents) || !$this.hasClass('propoElement'))
		{
			if(debug)
				console.log('processPropoElement: Failed: ', (!$parent.hasClass('propoContainer') ? 'offset parent missing propoContainer class' : ''), (!$this.hasClass('propoElement') ? 'missing propoElement class' : ''));
			return;
		}
		// If overrideNonPropoOffsetParents, search for the nearest propoContainer and append propoOverride to the propoElement
		else if(!(($parent.hasClass('propoContainer') && $parent.hasClass('propoContainerReady'))  && overrideNonPropoOffsetParents))
		{
			if(debug)
				console.log('processPropoElement: OVERRIDE: ', (!$parent.hasClass('propoContainer') ? 'offset parent missing propoContainer class' : ''), (!$this.hasClass('propoElement') ? 'missing propoElement class' : ''), 'using nearest propoContainer instead');
			$parent = $($this.parents('.propoContainer')[0]);
			$this.data('propoOverrideParent', $parent);
		
			if(debug)
				console.log('processPropoElement: OVERRIDE: Parent with max-width:', $parent.data('max_width'), 'and max-height:', $parent.data('max_height'));
			override_applied = true;
		}
	
		/* BEGIN: Positioning */
		// Clear old positioning if this element was already processed
		if($this.hasClass('propoElementReady'))
		{
			$this.css({
				left: '',
				top: '',
				right: '',
				bottom: '',
				width: '',
				height: ''
			});
		
			$this.removeClass('propoElementReady');
		}
	
		/*
		Hide element in Chrome/Firefox to acquire stylesheet positioning values,
		ie and safari return weird values if hidden
		*/
		if(!is_ie && !is_safari) $this.addClass('propoProcessing');
	
		/*
		Get current positions and calculate each percentage position
		Note: Right and Bottom will take priority over top. Overridden positions or 'unused' positions will result in "auto" 
		so that artifact positions values do not affect in-line positions generated by this script
		*/
		for(var position in positions)
		{
			if(positions.hasOwnProperty(position))
			{
				var current_position = $this.css(position),
				position_horizontal = position === 'left' || position === 'right' ? true : false,
				position_vertical = position === 'top' || position === 'bottom' ? true : false,
				parent_size = $parent.data(position_horizontal ? 'max_width' : (position_vertical ? 'max_height' : 'error'));
			
				/*
					Safari returns all position values as px; which leads to problems when handling % positioning. One of the things that can be done is to detect decimals...
					This will convert from percent to px position based on parent max-(sizes)
				*/
				if(is_safari)
				{
					var float_value = parseFloat($this.css(position).replace('px', '')),
					calculated_percentage;
					if($this.css(position) !== 'auto' &&  float_value % 1 !== 0)
					{
						calculated_percentage = float_value/(position_horizontal ? $parent.width() : $parent.height());
						current_position = calculated_percentage*parent_size+'px';
						if(parent_size === undefined)
						{
							delete positions[position];
							continue;
						}
					
						if(debug)
							console.log('processPropoElement: Safari:', position, ':', float_value, calculated_percentage, current_position, parent_size);
					}
				}
						
				/*
				 Check if percentage or "auto". Mark % positions as percentages 
				 such that % positions are skipped over (in favor of the stylesheet value)
				 */
				if(regex_percent.test(current_position))
				{
					if(debug)
						console.log('processPropoElement: % value found for position:', position, current_position);
				
					// Precedence! For bottom and right values
					if(position === 'bottom')
						positions.top = 'auto';
					if(position === 'right')
						positions.left = 'auto';
				
					delete positions[position];
					delete raw_positions[position];
					//console.log('deleted', 'position');
					continue;
				}
				/*
					Check if px value, convert into int
					create a percentage value to position to offset parent
				*/
				else if(regex_px.test(current_position))
				{	
					if(debug)
						console.log('processPropoElement: px value found for position:', position, current_position);
					
					// Precedence! For bottom and right values
					if(position === 'bottom')
						positions.top = 'auto';
					if(position === 'right')
						positions.left = 'auto';
				
					current_position = parseInt(current_position.replace('px' ,''));
					raw_positions[position] = current_position;
					if((position_horizontal && $parent.data('max_width') !== undefined) || (position_vertical && $parent.data('max_height') !== undefined))
						current_position = (current_position/parent_size)*100+'%'; // Change later
					else
					{
						delete positions[position];
						continue;
					}
				}
				else
				{
					auto_count++;
					if(current_position !== 'auto')
					{
						if(debug)
							console.log('processPropoElement: rejected value for position:', position, 'with value: ', current_position);
						current_position = 'auto';
					}
					else
					{
						if(debug)
							console.log('processPropoElement: no value for position:', position, 'with value: ', current_position);
						delete positions[position];
						delete raw_positions[position];
						continue;
					}
				}
			
				positions[position] = current_position;
			
			}
		}
	
		$this.removeClass('propoProcessing');
	
		if(debug)
			console.log(positions);
		
		// Set CSS values
		if(auto_count === 4)
		{
			if(debug)
				console.log('processPropoElement: No position css entered: Assuming non-absolute element');
			$this.css({position: 'relative'});
		}
	
		$this.data('propoPositions', raw_positions);
	
		for(var prop in positions)
		{
			if(positions.hasOwnProperty(prop))
				updated_properties.push(prop);
		}
	
		/* END: Positioning */
	
		/* BEGIN: Sizing */
		css_max_width = $this.css('max-width');
		css_max_height = $this.css('max-height');
	
		if(css_max_width !== 'none')
		{
			// Parent must have a max-width set for width scaling to happen
			if(regex_px.test(css_max_width) && $parent.data('max_width'))
			{
				max_width = (parseInt(css_max_width.replace('px', ''))/$parent.data('max_width'))*100+'%';
				positions['width'] = max_width;
				$this.data('propoMaxWidth', parseInt(css_max_width.replace('px', '')));
				updated_properties.push('width');
			}
		}
	
		if(css_max_height !== 'none')
		{
			// Parent must have a max-height set for width scaling to happen
			if(regex_px.test(css_max_height) && $parent.data('max_height'))
			{
				max_height = (parseInt(css_max_height.replace('px', ''))/$parent.data('max_height'))*100+'%';
				positions['height'] = max_height;
				$this.data('propoMaxHeight', parseInt(css_max_height.replace('px', '')));
				updated_properties.push('height');
			}
		}
		/* END: Sizing */
		$this.css(positions);
		$this.data('propoElementProps', updated_properties);
		$this.data('propoCSS', positions);
	
		// Mark element as processed
		$this.addClass('propoElementReady');
		// Defer resizing and positioning to resize or propoResize (later)
		// Ensure that otherwise possibly invalid CSS values are cleared
		if(overrideNonPropoOffsetParents && override_applied)
		{
			$this.addClass('propoOverride');
			$this.css({
				left: '',
				top: '',
				right: '',
				bottom: '',
				width: '',
				height: ''	
			});
		}
		if(debug)
			console.log('<<< processPropoElement: End: For id:', $this.attr('id'), 'class:', $this.attr('class'), 'for propoContainer with id:', $parent.attr('id'), 'class:', $parent.attr('id'), '>>>');
	};

	/**
	* Sets text within an element to resize. CSS values font-size (px), line-height, and letter-spacing are set for scaling.
	* @name processPropoText
	* @function external:"$.fn".processPropoText
	* @param {object} options - Contains options
	* 	@param {boolean} [options.debug=false] - Enables debug messages if true, will be false if console does not exist.
	*/
	$.fn.processPropoText = function(options){
		options = extendDefaults(options);
	
		var $this = $(this),
		debug = options.debug !== undefined ? (window.console ? options.debug : false) : false,
		$parent = $this.closest('.propoContainer.propoContainerReady'),
		css_font_size,
		css_line_height,
		css_letter_spacing,
		font_size = false,
		line_height = false,
		letter_spacing = false,
		parent_scale,
		regex_px = /[0-9]+(px){1}/,
		updated_properties = [];
	
		if(debug)
			console.log('<<< processPropoText: Start: for id:', $this.attr('id'), 'class:', $this.attr('class'), '>>>');
	
		// Must have propoText class and a propoContainer parent
		if(!$this.hasClass('propoText') || $parent.length === 0)
		{
			if(debug)
				console.log('processPropoText: failed');
			return;
		}
		// Clear any existing font size values and data set by the script
		if($this.hasClass('propoTextReady'))
		{
			$this.css({
				fontSize: '',
				letterSpacing: '',
				lineHeight: ''
			});
			$this.removeData([
				'font_size',
				'line_height',
				'letter_spacing'
			]);
			$this.removeClass('propoTextReady');
		}
	
		// Scaling uses parent width first, before checking height
		parent_scale = ($parent.data('max_width') ? $parent.width()/$parent.data('max_width') : $parent.data('max-height') ? $parent.height()/$parent.data : 1);
	
		css_font_size = $this.css('font-size');
		css_line_height = $this.css('line-height');
		css_letter_spacing = $this.css('letter-spacing');
	
		var css_data = {};
	
		font_size = parseInt(css_font_size.replace('px', ''));
		$this.data('font_size', font_size);
		css_data.fontSize = font_size*parent_scale+'px';
	
		// Do not allow non-numeric values to be scaled
		if(css_line_height !== 'normal')
		{
			// convert to a easy-to-use-multiplier
			if(regex_px.test(css_line_height))
				line_height = parseFloat(css_line_height.replace('px', ''));
			//else if(regex_percent.test(css_line_height))
			//	line_height = parseFloat(css_line_height.replace('%', ''))/100*font_size;
		
			if(line_height % 1 !== 0 || (regex_px.test(css_line_height) && line_height % font_size !== 0) || line_height % font_size === 0)
				line_height = line_height/font_size;

			$this.data('line_height', line_height);
			css_data.lineHeight = line_height;
		}
		// Do not allow non-numeric values to be scaled;
		if(css_letter_spacing !== 'normal')
		{
			letter_spacing = typeof css_letter_spacing === 'number' ? css_letter_spacing : parseFloat(css_letter_spacing.replace('px', ''));
			$this.data('letter_spacing', letter_spacing);
			css_data.letterSpacing = letter_spacing*parent_scale+'px';
		}
	
		$this.css(css_data);

	
		for(var prop in css_data)
		{
			if(css_data.hasOwnProperty(prop))
				updated_properties.push(prop);
		}
		$this.data('propoTextProps', updated_properties);
		if(debug)
			console.log('<<< processPropoText: End: for id:', $this.attr('id'), 'class:', $this.attr('class'), '>>>');
	};

	$.disablePropo = function(){
		var $propoContainers = $('.propoContainer').removeClass('propoContainerReady'),
		$propoElements = $('.propoElement').removeClass('propoElementReady'),
		$propoText = $('.propoText').removeClass('propoTextReady');
	
		//console.log('disablePropo: propoScript disabled');
	
		if(propoScriptProps.disabled || !propoScriptProps.init)	
				return;
	
		propoScriptProps.disabled = true;
	
		$propoContainers.each(function(){
			var $this = $(this),
			props = $this.data('propoContainerProps'),
			clearProps = {},
			c;
		
			props = typeof props === 'undefined' ? [] : props;
		
			for(c = 0; c < props.length; c++)
			{
				clearProps[props[c]] = '';
			}
			$this.css(clearProps);
		});
	
		$propoElements.each(function(){
			var $this = $(this),
			props = $this.data('propoElementProps'),
			clearProps = {},
			c;
		
			props = typeof props === 'undefined' ? [] : props;
		
			for(c = 0; c < props.length; c++)
			{
				clearProps[props[c]] = '';
			}
		
			$this.css(clearProps);
		});
	
		$propoText.each(function(){
			var $this = $(this),
			props = $this.data('propoTextProps'),
			clearProps = {},
			c;
			props = typeof props === 'undefined' ? [] : props;
		
			for(c = 0; c < props.length; c++)
			{
				clearProps[props[c]] = '';
			}
		
			$this.css(clearProps);
		});
	};

	$.enablePropo = function(){
		
		if(!propoScriptProps.disabled || !propoScriptProps.init)	
			return;
		
		propoScriptProps.disabled = false;
	
		$.processPropoItems(propoScriptProps.initSettings);
	};
});

